import React, { useState } from 'react';

const StrategicDecisions = () => {
  const [selectedDecision, setSelectedDecision] = useState(null);

  const strategicDecisions = [
    {
      month: "Agustus 2025",
      monthNumber: "08",
      phase: "Fase Inisiasi & Fondasi",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      keyDecision: "Memulai dengan Tim Internal & Sosialisasi Wali",
      decisions: [
        {
          decision: "Kick-off Tim Digitalisasi Terlebih Dahulu",
          rationale: "Tim internal harus solid dan memahami visi sebelum melibatkan stakeholder eksternal. Tanpa tim yang kompak, program akan kehilangan arah.",
          impact: "Memastikan koordinasi dan komunikasi yang efektif sepanjang program",
          riskMitigation: "Mencegah miskomunikasi dan tumpang tindih tugas antar divisi"
        },
        {
          decision: "Distribusi iPad ke Guru & Pengasuh Dulu, Bukan Santri",
          rationale: "Guru dan pengasuh adalah fasilitator utama. Mereka harus menguasai teknologi sebelum mengajarkan santri. Prinsip 'train the trainer' yang efektif.",
          impact: "Guru menjadi role model dan dapat memberikan bimbingan yang kompeten",
          riskMitigation: "Menghindari chaos jika santri mendapat iPad tanpa bimbingan yang memadai"
        }
      ]
    },
    {
      month: "September 2025",
      monthNumber: "09",
      phase: "Fase Persiapan Infrastruktur",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      keyDecision: "Prioritas Infrastruktur Sebelum Konten",
      decisions: [
        {
          decision: "Audit Infrastruktur IT Sebagai Prioritas Utama",
          rationale: "Infrastruktur adalah fondasi. Tanpa jaringan yang stabil dan storage yang memadai, semua program digital akan gagal. Better safe than sorry.",
          impact: "Memastikan sistem dapat menampung ribuan pengguna secara bersamaan",
          riskMitigation: "Mencegah downtime dan frustrasi pengguna karena masalah teknis"
        },
        {
          decision: "Workshop RPP Digital Dimulai Sekarang",
          rationale: "Guru perlu waktu untuk adaptasi metodologi baru. Memulai workshop RPP digital bersamaan dengan persiapan infrastruktur mengoptimalkan waktu.",
          impact: "Guru siap dengan konten digital saat infrastruktur selesai",
          riskMitigation: "Mencegah keterlambatan implementasi karena konten belum siap"
        }
      ]
    },
    {
      month: "Oktober 2025",
      monthNumber: "10",
      phase: "Fase Integrasi Sistem",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      keyDecision: "Integrasi Sistem Pendidikan & Pengasuhan",
      decisions: [
        {
          decision: "Setup MDM & LMS Bersamaan",
          rationale: "MDM dan LMS harus terintegrasi dari awal. Setup terpisah akan menyulitkan sinkronisasi data dan mengurangi efektivitas kontrol perangkat.",
          impact: "Sistem terpadu yang memungkinkan monitoring holistik santri",
          riskMitigation: "Mencegah fragmentasi data dan kesulitan integrasi di kemudian hari"
        },
        {
          decision: "Perancangan Akun Guru & Musyrif Bersamaan",
          rationale: "Pendidikan dan pengasuhan di pesantren tidak terpisah. Akun yang terintegrasi memungkinkan kolaborasi guru-musyrif dalam pembinaan santri.",
          impact: "Komunikasi dan koordinasi yang seamless antara akademik dan pengasuhan",
          riskMitigation: "Menghindari silo informasi yang dapat merugikan perkembangan santri"
        }
      ]
    },
    {
      month: "November 2025",
      monthNumber: "11",
      phase: "Fase Standardisasi & Regulasi",
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      keyDecision: "Penetapan SOP & Standar Konten",
      decisions: [
        {
          decision: "Penyusunan SOP iPad & LMS Sebelum Pilot",
          rationale: "SOP yang jelas mencegah chaos saat implementasi. Aturan main harus ditetapkan sebelum santri menggunakan perangkat.",
          impact: "Penggunaan iPad yang tertib dan sesuai tujuan pendidikan",
          riskMitigation: "Mencegah penyalahgunaan perangkat dan gangguan pembelajaran"
        },
        {
          decision: "Uji Coba Blended & Flipped Classroom",
          rationale: "Metodologi pembelajaran harus diuji sebelum implementasi massal. Blended learning cocok untuk pesantren yang menggabungkan tradisional dan modern.",
          impact: "Metodologi pembelajaran yang terbukti efektif",
          riskMitigation: "Menghindari kegagalan metodologi saat implementasi penuh"
        }
      ]
    },
    {
      month: "Desember 2025",
      monthNumber: "12",
      phase: "Fase Pilot Project",
      color: "from-red-500 to-red-600",
      bgColor: "bg-red-50",
      keyDecision: "Implementasi Pilot Terbatas & Terkontrol",
      decisions: [
        {
          decision: "Pengadaan iPad Siswa Hanya untuk Kelas Pilot",
          rationale: "Pilot project dengan skala terbatas memungkinkan kontrol yang ketat dan pembelajaran yang mendalam sebelum ekspansi. Risk management yang baik.",
          impact: "Pembelajaran intensif dari implementasi terbatas",
          riskMitigation: "Membatasi dampak jika terjadi masalah pada tahap awal"
        },
        {
          decision: "Produksi Konten Semester Genap Dimulai",
          rationale: "Lead time produksi konten cukup panjang. Memulai produksi sekarang memastikan konten siap saat implementasi penuh di semester genap.",
          impact: "Konten pembelajaran yang siap pakai untuk semester genap",
          riskMitigation: "Mencegah keterlambatan implementasi karena konten belum siap"
        }
      ]
    },
    {
      month: "Januari 2026",
      monthNumber: "01",
      phase: "Fase Integrasi Penilaian Digital",
      color: "from-teal-500 to-teal-600",
      bgColor: "bg-teal-50",
      keyDecision: "Integrasi Holistik Penilaian Akademik & Karakter",
      decisions: [
        {
          decision: "Integrasi Penilaian Digital Akademik & Pengasuhan Bersamaan",
          rationale: "Di pesantren, penilaian akademik dan karakter tidak dapat dipisahkan. Integrasi sejak awal memastikan evaluasi holistik santri sesuai filosofi pendidikan Islam.",
          impact: "Penilaian komprehensif yang mencakup aspek kognitif, afektif, dan psikomotorik",
          riskMitigation: "Mencegah fragmentasi data dan memastikan konsistensi penilaian"
        },
        {
          decision: "Implementasi Assessment for/as/of Learning Berbasis Digital",
          rationale: "Tiga jenis assessment ini memberikan gambaran lengkap: diagnostic (for), formatif (as), dan sumatif (of). Digital memungkinkan implementasi yang lebih efisien dan akurat.",
          impact: "Sistem penilaian yang komprehensif dan mendukung pembelajaran berkelanjutan",
          riskMitigation: "Menghindari bias penilaian dan memastikan objektivitas evaluasi"
        }
      ]
    },
    {
      month: "Februari 2026",
      monthNumber: "02",
      phase: "Fase Pelatihan Santri & Simulasi",
      color: "from-pink-500 to-pink-600",
      bgColor: "bg-pink-50",
      keyDecision: "Edukasi Adab Digital & Simulasi Terkontrol",
      decisions: [
        {
          decision: "Pelatihan Siswa Pilot Sebelum Simulasi Sistem",
          rationale: "Santri harus memahami etika dan tanggung jawab digital sebelum menggunakan sistem. Pelatihan yang baik mencegah penyalahgunaan dan memaksimalkan manfaat.",
          impact: "Santri yang bertanggung jawab dan mampu menggunakan teknologi dengan bijak",
          riskMitigation: "Mencegah cyberbullying, penyalahgunaan internet, dan gangguan pembelajaran"
        },
        {
          decision: "Edukasi Adab Digital Terintegrasi dengan Nilai Islami",
          rationale: "Teknologi harus sejalan dengan akhlak Islami. Edukasi adab digital memastikan penggunaan teknologi tidak bertentangan dengan nilai-nilai pesantren.",
          impact: "Santri yang menggunakan teknologi dengan akhlak mulia dan tujuan yang baik",
          riskMitigation: "Mencegah degradasi moral dan mempertahankan identitas Islami"
        }
      ]
    },
    {
      month: "Maret 2026",
      monthNumber: "03",
      phase: "Fase Evaluasi & Optimalisasi",
      color: "from-indigo-500 to-indigo-600",
      bgColor: "bg-indigo-50",
      keyDecision: "Evaluasi Komprehensif & Continuous Improvement",
      decisions: [
        {
          decision: "Evaluasi Pilot Project Melibatkan Semua Stakeholder",
          rationale: "Evaluasi yang objektif memerlukan input dari guru, santri, wali santri, dan manajemen. Perspektif multi-stakeholder memberikan gambaran yang utuh.",
          impact: "Perbaikan sistem berdasarkan feedback komprehensif dari semua pengguna",
          riskMitigation: "Mencegah bias evaluasi dan memastikan solusi yang tepat sasaran"
        },
        {
          decision: "Focus Group Discussion (FGD) untuk Masukan Lapangan",
          rationale: "FGD memberikan insight mendalam yang tidak bisa didapat dari survei. Diskusi terbuka mengungkap masalah tersembunyi dan solusi kreatif.",
          impact: "Pemahaman mendalam tentang tantangan implementasi dan solusi praktis",
          riskMitigation: "Mengidentifikasi dan mengatasi masalah sebelum implementasi penuh"
        }
      ]
    },
    {
      month: "April 2026",
      monthNumber: "04",
      phase: "Fase Implementasi Penuh",
      color: "from-emerald-500 to-emerald-600",
      bgColor: "bg-emerald-50",
      keyDecision: "Ekspansi Menyeluruh dengan Sistem Matang",
      decisions: [
        {
          decision: "Distribusi iPad Batch Akhir ke Semua Santri",
          rationale: "Setelah pilot project berhasil dan sistem telah dioptimalisasi, saatnya implementasi penuh. Distribusi serentak memastikan kesetaraan akses untuk semua santri.",
          impact: "Semua santri memiliki akses yang sama terhadap pembelajaran digital",
          riskMitigation: "Sistem sudah teruji dan stabil, mengurangi risiko kegagalan massal"
        },
        {
          decision: "Setup Sistem Penuh di Semua Unit Bersamaan",
          rationale: "Implementasi serentak di semua unit mencegah kesenjangan dan memastikan standar yang sama. Koordinasi terpusat lebih efisien daripada bertahap.",
          impact: "Standarisasi sistem dan proses di seluruh unit pendidikan",
          riskMitigation: "Tim teknis sudah berpengalaman dari pilot project, mengurangi risiko implementasi"
        }
      ]
    },
    {
      month: "Mei 2026",
      monthNumber: "05",
      phase: "Fase Simulasi Penuh & Finalisasi",
      color: "from-amber-500 to-amber-600",
      bgColor: "bg-amber-50",
      keyDecision: "Uji Coba Menyeluruh & Persiapan Go-Live",
      decisions: [
        {
          decision: "Simulasi Penuh 1 Minggu untuk Semua Aktivitas",
          rationale: "Simulasi penuh memberikan gambaran nyata operasional harian. Satu minggu cukup untuk mengidentifikasi masalah operasional tanpa mengganggu pembelajaran terlalu lama.",
          impact: "Validasi kesiapan sistem untuk operasional penuh dan identifikasi masalah terakhir",
          riskMitigation: "Deteksi dini masalah operasional sebelum launching resmi"
        },
        {
          decision: "Finalisasi Konten Semester Ganjil 2026/2027",
          rationale: "Konten harus siap sebelum tahun ajaran baru dimulai. Finalisasi di Mei memberikan waktu buffer untuk perbaikan jika diperlukan.",
          impact: "Konten pembelajaran yang lengkap dan berkualitas untuk tahun ajaran baru",
          riskMitigation: "Mencegah keterlambatan pembelajaran karena konten belum siap"
        }
      ]
    },
    {
      month: "Juni 2026",
      monthNumber: "06",
      phase: "Fase Persiapan Akhir & Audit",
      color: "from-violet-500 to-violet-600",
      bgColor: "bg-violet-50",
      keyDecision: "Audit Keamanan & Refreshment Training",
      decisions: [
        {
          decision: "Audit Keamanan Data Sebelum Go-Live",
          rationale: "Keamanan data santri adalah prioritas utama. Audit menyeluruh memastikan tidak ada celah keamanan yang dapat dieksploitasi pihak tidak bertanggung jawab.",
          impact: "Sistem yang aman dan terpercaya untuk melindungi data pribadi santri",
          riskMitigation: "Mencegah kebocoran data dan menjaga kepercayaan wali santri"
        },
        {
          decision: "Refreshment Training untuk Semua Pengguna",
          rationale: "Training ulang memastikan semua pengguna siap dengan sistem final. Penyegaran pengetahuan mencegah kesalahan operasional saat go-live.",
          impact: "Pengguna yang kompeten dan percaya diri menggunakan sistem",
          riskMitigation: "Mengurangi human error dan memastikan adopsi yang smooth"
        }
      ]
    },
    {
      month: "Juli 2026",
      monthNumber: "07",
      phase: "Fase Launching & Go-Live",
      color: "from-rose-500 to-rose-600",
      bgColor: "bg-rose-50",
      keyDecision: "Launching Resmi & Transisi ke Operasional",
      decisions: [
        {
          decision: "Launching Sistem Digital untuk Tahun Ajaran 2026/2027",
          rationale: "Launching di awal tahun ajaran memberikan fresh start dan momentum positif. Semua stakeholder siap memulai era baru pendidikan digital.",
          impact: "Transisi resmi ke era pendidikan digital yang terintegrasi penuh",
          riskMitigation: "Semua persiapan telah matang, mengurangi risiko kegagalan launching"
        },
        {
          decision: "Penetapan SOP Permanen & Roadmap CQI Jangka Panjang",
          rationale: "SOP permanen memberikan kepastian operasional. Roadmap Continuous Quality Improvement memastikan sistem terus berkembang dan tidak stagnan.",
          impact: "Operasional yang stabil dengan mekanisme perbaikan berkelanjutan",
          riskMitigation: "Mencegah stagnasi dan memastikan adaptasi terhadap perkembangan teknologi"
        }
      ]
    }
  ];

  const decisionPrinciples = [
    {
      principle: "Sequential Logic",
      description: "Setiap keputusan diambil berdasarkan hasil tahap sebelumnya",
      icon: "fas fa-arrow-right",
      color: "text-blue-600"
    },
    {
      principle: "Risk Mitigation",
      description: "Setiap keputusan mempertimbangkan dan memitigasi risiko potensial",
      icon: "fas fa-shield-alt",
      color: "text-green-600"
    },
    {
      principle: "Stakeholder Alignment",
      description: "Keputusan melibatkan dan mempertimbangkan semua stakeholder",
      icon: "fas fa-users",
      color: "text-purple-600"
    },
    {
      principle: "Evidence-Based",
      description: "Keputusan berdasarkan data, feedback, dan hasil evaluasi",
      icon: "fas fa-chart-bar",
      color: "text-orange-600"
    }
  ];

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full mb-6">
            <i className="fas fa-chess text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Keputusan Strategis
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Analisis mendalam logika dan alasan di balik setiap keputusan strategis dalam roadmap digitalisasi Al Wafi, berdasarkan prinsip What-Why-How yang terstruktur
          </p>
        </div>

        {/* Decision Principles */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Prinsip Pengambilan Keputusan</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {decisionPrinciples.map((principle, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className={`w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${principle.icon} ${principle.color} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2">{principle.principle}</h3>
                <p className="text-gray-600 text-sm">{principle.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Strategic Decisions Timeline */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Timeline Keputusan Strategis</h2>
          <div className="space-y-6">
            {strategicDecisions.map((monthData, index) => (
              <div key={index} className={`${monthData.bgColor} rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden`}>
                <div className={`h-2 bg-gradient-to-r ${monthData.color}`}></div>
                <div className="p-6">
                  <div 
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setSelectedDecision(selectedDecision === index ? null : index)}
                  >
                    <div className="flex items-center space-x-4">
                      <div className={`w-16 h-16 bg-gradient-to-r ${monthData.color} rounded-full flex items-center justify-center`}>
                        <span className="text-white font-bold text-lg">{monthData.monthNumber}</span>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800">{monthData.month}</h3>
                        <p className="text-gray-600 text-lg">{monthData.phase}</p>
                        <div className="mt-2">
                          <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${monthData.color} text-white`}>
                            <i className="fas fa-key mr-2"></i>
                            {monthData.keyDecision}
                          </span>
                        </div>
                      </div>
                    </div>
                    <i className={`fas ${selectedDecision === index ? 'fa-chevron-up' : 'fa-chevron-down'} text-gray-400 text-xl`}></i>
                  </div>

                  {selectedDecision === index && (
                    <div className="mt-6 space-y-6">
                      {monthData.decisions.map((decision, decisionIndex) => (
                        <div key={decisionIndex} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
                          <div className="flex items-start space-x-4">
                            <div className={`w-10 h-10 bg-gradient-to-r ${monthData.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                              <span className="text-white font-bold">{decisionIndex + 1}</span>
                            </div>
                            <div className="flex-1">
                              <h4 className="text-xl font-bold text-gray-800 mb-3">{decision.decision}</h4>
                              
                              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                {/* Rationale */}
                                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                  <h5 className="font-semibold text-yellow-800 mb-2 flex items-center">
                                    <i className="fas fa-lightbulb text-yellow-600 mr-2"></i>
                                    Alasan Logis
                                  </h5>
                                  <p className="text-yellow-700 text-sm leading-relaxed">{decision.rationale}</p>
                                </div>

                                {/* Impact */}
                                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                                  <h5 className="font-semibold text-green-800 mb-2 flex items-center">
                                    <i className="fas fa-bullseye text-green-600 mr-2"></i>
                                    Dampak Positif
                                  </h5>
                                  <p className="text-green-700 text-sm leading-relaxed">{decision.impact}</p>
                                </div>

                                {/* Risk Mitigation */}
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                                  <h5 className="font-semibold text-blue-800 mb-2 flex items-center">
                                    <i className="fas fa-shield-alt text-blue-600 mr-2"></i>
                                    Mitigasi Risiko
                                  </h5>
                                  <p className="text-blue-700 text-sm leading-relaxed">{decision.riskMitigation}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Decision Framework */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Framework Keputusan Strategis</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-question text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">WHAT</h3>
                <p className="text-indigo-100">Keputusan apa yang diambil dan aktivitas apa yang dilakukan</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lightbulb text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">WHY</h3>
                <p className="text-indigo-100">Mengapa keputusan tersebut penting dan logis untuk diambil</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-cogs text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-2">HOW</h3>
                <p className="text-indigo-100">Bagaimana implementasi dan mitigasi risiko dilakukan</p>
              </div>
            </div>
          </div>
        </section>

        {/* Key Insights */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Key Insights Keputusan</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  <i className="fas fa-lightbulb text-yellow-500 mr-3"></i>
                  Pola Keputusan
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span className="text-gray-700">Selalu memulai dengan persiapan internal sebelum eksternal</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span className="text-gray-700">Infrastruktur dan SDM dipersiapkan bersamaan</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span className="text-gray-700">Pilot project sebelum implementasi penuh</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-green-500 mt-1"></i>
                    <span className="text-gray-700">Evaluasi dan perbaikan berkelanjutan</span>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                  <i className="fas fa-shield-alt text-blue-500 mr-3"></i>
                  Mitigasi Risiko
                </h3>
                <ul className="space-y-3">
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-blue-500 mt-1"></i>
                    <span className="text-gray-700">Setiap keputusan mempertimbangkan worst-case scenario</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-blue-500 mt-1"></i>
                    <span className="text-gray-700">Implementasi bertahap untuk mengurangi risiko</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-blue-500 mt-1"></i>
                    <span className="text-gray-700">Backup plan dan contingency selalu disiapkan</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-blue-500 mt-1"></i>
                    <span className="text-gray-700">Feedback loop untuk perbaikan cepat</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl p-8 text-white">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6">
              <i className="fas fa-chess text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl font-bold mb-4">Keputusan yang Terstruktur & Logis</h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Setiap keputusan dalam roadmap digitalisasi Al Wafi diambil berdasarkan analisis mendalam, pertimbangan risiko, dan logika yang kuat untuk memastikan kesuksesan program
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-indigo-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-download mr-2"></i>
                Download Analisis
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-indigo-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-comments mr-2"></i>
                Diskusi Strategi
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default StrategicDecisions;
